"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const store_1 = require("./store");
const banner_scss_1 = __importDefault(require("./styles/banner.scss"));
const region_scss_1 = __importDefault(require("./styles/region.scss"));
const Transition_1 = require("./Transition");
function GameView({ iframeRef }) {
    const dispatch = react_redux_1.useDispatch();
    const bringGameFront = react_redux_1.useSelector((state) => state.mode.bringGameFront);
    const lv = react_redux_1.useSelector((state) => state.sandbox.localVersion);
    const rv = react_redux_1.useSelector((state) => state.sandbox.runningVersion);
    const version = react_redux_1.useSelector((state) => state.sandbox.version);
    const [focused, setFocused] = React.useState(false);
    React.useEffect(() => {
        const blur = () => {
            if (window.document.activeElement === iframeRef.current) {
                // focused on iframe
                dispatch(store_1.actions.bringGameFront(true));
                dispatch(store_1.actions.runSanbox());
                setFocused(true);
            }
        };
        const focus = () => {
            setFocused(false);
        };
        window.addEventListener('blur', blur, { passive: true });
        window.addEventListener('focus', focus, { passive: true });
        return () => {
            window.removeEventListener('blur', blur);
            window.removeEventListener('focus', focus);
        };
    }, []);
    return (React.createElement("div", { className: classnames_1.default(region_scss_1.default.output, bringGameFront && region_scss_1.default.bringFront) },
        React.createElement(Transition_1.Transition, { in: !focused, className: banner_scss_1.default.wrapper, exiting: banner_scss_1.default.exiting }, version <= rv ? (React.createElement("div", { className: banner_scss_1.default.black },
            React.createElement("img", { src: require('./resources/paperPlane.svg'), alt: "\u2708\uFE0E" }),
            React.createElement("span", null, 'Playing the latest version'))) : version === lv ? (React.createElement("div", { className: banner_scss_1.default.black },
            React.createElement("img", { src: require('./resources/paperPlane.svg'), alt: "\u2708\uFE0E" }),
            React.createElement("span", null, 'Updated by you'))) : (React.createElement("div", { style: { backgroundColor: '#F1C40F' } },
            React.createElement("img", { src: require('./resources/paperPlane.svg'), alt: "\u2708\uFE0E" }),
            React.createElement("span", null, 'Updated by Teramoto')))),
        React.createElement("iframe", { src: "https://hackforplay-sandbox.firebaseapp.com/compatible.html", frameBorder: "0", ref: iframeRef })));
}
exports.GameView = GameView;
